import * as types from '../actionsTypes/individuoActionType';
import new_axios_istance from '../../axios_instance';


export const getIndividui = (individui) => ({
    type: types.GET_INDIVIDUI,
    individui
})

export const getIndividuiByObjectIdSuccess = (individui) => ({
    type: types.GET_INDIVIDUI_BY_OBJECTID_SUCCESS,
    individui
});

export const getDocentiByObjectIdSuccess = (docenti) => ({
    type: types.GET_DOCENTI_BY_OBJECTID_SUCCESS,
    docenti,
});

export const setIndividuiSelezionati = (arrObjIdIndividui) => ({
    type: types.SET_INDIVIDUI_SELEZIONATI,
    arrObjIdIndividui: arrObjIdIndividui
});

export const initIndividuiSelezionati = () => ({
    type: types.INIT_INDIVIDUI_SELEZIONATI
});

export const initIndividui = () => ({
    type: types.INIT_INDIVIDUI
});

export const initDocenti = () => ({
    type: types.INIT_DOCENTI
});

export const getAnagraficaByIdUniversale = (idUniversale) => new_axios_istance.get(`/v1/utenteanagrafica/recupera/iduniversale/${idUniversale}`);
